import { render, staticRenderFns } from "./studentsTable.vue?vue&type=template&id=0ccf8738&"
import script from "./studentsTable.vue?vue&type=script&lang=js&"
export * from "./studentsTable.vue?vue&type=script&lang=js&"
import style0 from "./studentsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports